import ModalBody from '@space-core/components/modalBody'
import { focusVisible, customMedia } from '@space-core/styles'
import styled from 'styled-components'

export const CloseButton = styled.button`
  background: 0;
  ${focusVisible}
`

export const Label = styled.label`
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  height: 2.625rem;
  margin: 0;
`

export const ModalBodyCustom = styled(ModalBody)`
  overflow-y: auto;
  height: 60vh;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;
  ::-webkit-scrollbar {
    display: none;
  }
  ::-moz-scrollbar {
    display: none;
  }
  ${customMedia.lessThan('lg')`
    height: 75vh;
  `}
`

export const WrapperContent = styled.div`
  width: 98.5%;

  &:hover {
    background-color: var(--gray-200);
    border-radius: var(--border-radius-lg);
  }
`

export const Card = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, auto));
  width: 98%;

  .content:first-child {
    text-transform: lowercase !important;

    &:first-letter {
      text-transform: capitalize !important;
    }
  }

  p:nth-child(2) {
    color: var(--gray-900);
  }

  &:hover {
    p:nth-child(2) {
      color: var(--red-dark);
    }
  }
`

export const Image = styled.img`
  max-height: 4.5rem;
`

export const Text = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  ${customMedia.lessThan('lg')`
    -webkit-line-clamp: 2;
  `}
`
